import React from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

function TextInput({ name, value, handleChange, ...props }) {
  return (
    <Input
      autocomplete="new"
      {...props}
      name={name}
      value={value}
      onChange={handleChange}
    />
  );
}
TextInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  type: PropTypes.string
};
TextInput.defaultProps = {
  value: ""
};
export default TextInput;
